import React from "react"
import IconWithTooltip from "../../molecules/IconWithTooltip.molecule"
import PropTypes from "prop-types"
import { Skeleton } from "../../atoms/misc/Skeleton.atom"
import VacationDayVariantChip from "../../../components/molecules/VacationDayVariantChip.molecule"
import IconWithTooltipAndCustomBody from "../../molecules/IconWithTooltipAndCustomBody.molecule"
import { BREAKPOINTS } from "../../../consts/responsiveBreakpoints.consts"
import {
  VACATION_DAY_TYPE_COPYS,
  VACATION_DAY_TYPES,
} from "../../../consts/modules/vacations.consts"
import useScreenDimensionsContext from "../../../hooks/contextConsumers/useScreenDimensionsContext.hook"

export const ValueWithLabelTemplate = ({
  label,
  value,
  showZeroValue = false,
  labelTooltip,
  labelTooltipContent,
  labelTooltipPosition,
  labelTooltipIcon,
  showWarningBadge,
  loading,
  className,
  cols = null,
}) => {
  const { screenWidth } = useScreenDimensionsContext()

  const renderIconWithTooltip = () => {
    if (
      typeof labelTooltipContent === "string" ||
      typeof labelTooltipContent === "number"
    ) {
      return (
        <IconWithTooltip
          tooltipValue={labelTooltipContent}
          position={labelTooltipPosition}
          iconClassName={`${labelTooltipIcon} mx-1`}
        />
      )
    }
    if (React.isValidElement(labelTooltipContent)) {
      return (
        <IconWithTooltipAndCustomBody
          iconClassName={`${labelTooltipIcon} mx-1`}
          tooltipBody={labelTooltipContent}
          position={labelTooltipPosition}
        />
      )
    }
  }
  return (
    <div
      className={`value-with-label-template value-with-label-template--label-only flex flex-column white-space-nowrap gap-2 ${className} ${cols ? `col col-${cols}` : "flex-1 flex-shrink-0"}`}
    >
      <span className="label font-semibold text-base font-mulish">
        {label}
        {labelTooltip && renderIconWithTooltip()}
      </span>
      {(
        screenWidth <= BREAKPOINTS.MOBILE_BREAKPOINT && label === "Días tomados"
      ) ?
        <VacationDayVariantChip dayType={VACATION_DAY_TYPES.TAKEN} />
      : null}
      {(
        screenWidth <= BREAKPOINTS.MOBILE_BREAKPOINT &&
        label === VACATION_DAY_TYPE_COPYS.ACCORDED
      ) ?
        "Disponibles"
      : null}
      <span
        className="value font-cairo font-semibold"
        style={{
          color: showWarningBadge ? "var(--clr-danger)" : "var(--text-color)",
          textWrap: "wrap",
        }}
      >
        {loading ?
          <Skeleton className="loading-skeleton" />
        : typeof value === "function" ?
          value()
        : value || (showZeroValue ? 0 : "")}
        {showWarningBadge && <i className="pi pi-exclamation-triangle ml-1" />}
      </span>
    </div>
  )
}

export const ValueWithLabelContainer = ({
  children,
  className = "",
  vertical = false,
  grid = false,
  gap = "16px",
}) => {
  return (
    <div
      className={`value-with-label-container flex flex-wrap justify-content-center ${vertical && "flex-column"} ${className} ${grid ? "grid" : ""}`}
      style={{ gap: gap && !grid ? gap : undefined }}
    >
      {children}
    </div>
  )
}

export const ValueLabelStackTemplate = ({
  value,
  label,
  color,
  className = "",
}) => {
  return (
    <div
      className={`value-with-label-template flex align-items-center gap-3 ${className}`}
    >
      {color && (
        <div
          className="value-label-stack-color border-round-md flex-shrink-0"
          style={{ background: color }}
        />
      )}

      <div className="flex flex-column gap-1">
        <div
          className="value-label-stack-value"
          style={{
            fontSize: "24px !important",
            fontWeight: 600,
            fontFamily: "var(--font-cairo, 'Cairo', sans-serif)",
            color: "var(--text-color)",
            lineHeight: 1.2,
            textWrap: "wrap",
          }}
        >
          {value}
        </div>

        <span
          className="label font-semibold text-base font-mulish"
          style={{ fontSize: "18px" }} // Asegurar tamaño base
        >
          {label}
        </span>
      </div>
    </div>
  )
}
ValueLabelStackTemplate.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  color: PropTypes.string,
  loading: PropTypes.bool,
  className: PropTypes.string,
}

ValueWithLabelTemplate.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.func,
  ]),
  labelTooltip: PropTypes.bool,
  labelTooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelTooltipPosition: PropTypes.string,
  labelTooltipIcon: PropTypes.string,
  showWarningBadge: PropTypes.bool,
}

ValueWithLabelContainer.propTypes = {
  children: PropTypes.node,
}
